import Dialog from './Dialog.vue';

Dialog.install = (Vue) => {
  Vue.component(Dialog.name, Dialog);
};

export default Dialog;
